export const buildNavLinkClickHandler =
  (isCurrentPage: boolean) => (e: React.MouseEvent) => {
    if (isCurrentPage) {
      e.preventDefault();
    } else {
      e.stopPropagation();
    }
  };
